// App.tsx
import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ThemeContext from './utils/ThemeContext';
import Navbar from './components/NavBar';
import Home from './pages/Home';
import Simulados from './pages/Simulados';
import Informacoes from './pages/Informacoes';
import Aviacao from './pages/Aviacao';
import Fraseologia from './pages/Fraseologia';

const App: React.FC = () => {
  const { darkMode, toggleTheme } = useContext(ThemeContext);

  return (
    <HelmetProvider>
      <Router>
        <Navbar onThemeChange={toggleTheme} darkMode={darkMode} />
        <Box sx={{ marginTop: '64px', padding: '20px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/simulados" element={<Simulados />} />
            <Route path="/informacoes" element={<Informacoes />} />
            <Route path="/aviacao" element={<Aviacao />} />
            <Route path="/fraseologia" element={<Fraseologia />} />
          </Routes>
        </Box>
      </Router>
    </HelmetProvider>
  );
};

export default App;
